export const EVALUATION_INFERENCE_PROVIDER_IDS = [
  'bedrock',
  'bedrock_cvp',
  'vertex',
  'anthropic',
  'fireworks',
] as const;

export type EvaluationInferenceProviderId =
  (typeof EVALUATION_INFERENCE_PROVIDER_IDS)[number];

export const EVALUATION_REASONING_EFFORTS = [
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
] as const;

export type EvaluationReasoningEffort =
  (typeof EVALUATION_REASONING_EFFORTS)[number];

export type EvaluationModelVendor =
  | 'anthropic'
  | 'fireworks'
  | 'google'
  | 'meta'
  | 'nvidia'
  | 'openai'
  | 'vertex'
  | 'xai';
